module.exports = __webpack_public_path__ + "static/media/whichThinnerRegularBloodTests.4cc165c4.mp3";